import type { ConfiguratorValue } from "../../contract/configuration";

export const getRenderedControlValues = (
  values: readonly ConfiguratorValue[],
  hideDisabled = false,
  sortSelectableFirst = false,
  hiddenValues: readonly string[] = [],
): readonly ConfiguratorValue[] => {
  const visibleValues =
    hiddenValues.length === 0 ? values : values.filter((value) => !hiddenValues.includes(value.value));
  if (hideDisabled) {
    return visibleValues.filter((value) => value.selectable);
  }
  if (!sortSelectableFirst) {
    return visibleValues;
  }
  return [...visibleValues.filter((value) => value.selectable), ...visibleValues.filter((value) => !value.selectable)];
};
